const atosRich = {
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
      lg: 1280,
      md: 960,
      sm: 641,
      xl: 1920,
      xs: 0,
    },
  },
  opacity: {
    '08': 0.08,
    '12': 0.12,
    '16': 0.16,
    '24': 0.24,
    '32': 0.32,
    '40': 0.4,
    '48': 0.48,
    '56': 0.56,
    '64': 0.64,
    '72': 0.72,
    '80': 0.8,
    '88': 0.88,
    '96': 0.96,
  },
  palette: {
    action: {
      grayDark: '#494949',
      grayLight: '#666666',
      primary: '#0066A1',
    },
    avatar: {
      ash: '#666666',
      blueberry: '#5A5ABF',
      brass: '#8E6B2B',
      global: '#4D9AC7',
      gold: '#7A7000',
      lake: '#1A70C1',
      oasis: '#04549F',
      pear: '#3C7E44',
      persimmon: '#A14B00',
      sage: '#047C68',
      tomato: '#C93637',
    },
    content: {
      brand: '#0066A1',
    },
    danger: {
      b01: '#FFF7F5',
      b02: '#FFE5E0',
      b03: '#E6413C',
      b04: '#D63E39',
      f01: '#FFE5E0',
      f02: '#BE3933',
      f11: '#F88878',
    },
    dialHeader: {
      avatarBg: '#FFFFFF',
      avatarIcon: '#0066A1',
      bg: '#0066A1',
      focusBorder: '#FFFFFF',
      icon: '#FFFFFF',
      text: '#FFFFFF',
      textHint: 'rgba(255,255,255,0.72)',
    },
    disabled: {
      b01: '#B9B9B9',
      f01: '#FFFFFF',
      f02: '#B9B9B9',
    },
    error: {
      main: '#D63E39',
    },
    header: {
      bgLeft: '#0066A1',
      bgOverlay: 'rgba(255,255,255,0.16)',
      bgOverlayDisabled: 'rgba(255,255,255,0.08)',
      bgRight: '#4D9AC7',
      border: 'transparent',
      divider: 'rgba(0,0,0,0.12)',
      fabBg: '#FFFFFF',
      fabIcon: '#121212',
      focusBorder: '#FFFFFF',
      icon: '#FFFFFF',
      iconDisabled: 'rgba(255,255,255,0.32)',
      text: '#FFFFFF',
      textHint: 'rgba(255,255,255,0.48)',
    },
    highContrast: 'transparent',
    highlight: {
      b01: '#FF8800',
      b02: '#FFDFB1',
      b03: '#FA560A',
      f01: '#121212',
      f02: '#FA560A',
    },
    info: {
      main: '#666666',
    },
    informative: {
      b01: '#F6F9FC',
      f01: '#E3EBF4',
      f02: '#066FAC',
    },
    interactive: {
      b01: '#E6F2F8',
      b02: '#0066A1',
      f01: '#0066A1',
    },
    label: {
      black02: '#121212',
      blue01: '#066FAC',
      blue02: '#066FAC',
      green01: '#3C9949',
      green02: '#32773B',
      orange01: '#CD6E0D',
      orange02: '#A15600',
      purple01: '#8A77E3',
      purple02: '#6C5DAF',
      red01: '#E6413C',
      red02: '#BE3933',
      teal01: '#3093A4',
      teal02: '#2B727F',
      yellow01: '#B17D1A',
      yellow02: '#896219',
    },
    nav: {
      b01: '#FFFFFF',
      b02: '#F9F9F9',
      bookmark: '#0066A1',
      ctlDefault: '#939393',
      ctlSelected: '#0066A1',
      f01: '#757575',
      f02: '#666666',
      f03: '#494949',
      f04: '#121212',
      iconDefault: '#121212',
      iconSelected: '#0066A1',
      line: '#E5E5E5',
      mention: '#FA560A',
      menuBg: '#0066A1',
      menuText: '#FFFFFF',
    },
    neutral: {
      b01: '#FFFFFF',
      b02: '#F9F9F9',
      b03: '#F3F3F3',
      b04: '#666666',
      b05: '#494949',
      b06: '#000000',
      elevation: '#FFFFFF',
      f01: '#FFFFFF',
      f02: '#939393',
      f03: '#757575',
      f04: '#666666',
      f05: '#494949',
      f06: '#121212',
      f07: '#121212',
      f11: '#FFFFFF',
      l01: '#FFFFFF',
      l02: '#E5E5E5',
      l03: '#C7C7C7',
      l04: '#666666',
      transparent: 'transparent',
    },
    presence: {
      available: '#3C9949',
      busy: '#E6413C',
      invisible: '#939393',
    },
    primary: {
      main: '#0066A1',
    },
    secondary: {
      main: '#FF8800',
    },
    subAction: '#0066A1',
    success: {
      b01: '#F0FCEF',
      b02: '#CEF4CE',
      b03: '#3C9949',
      b04: '#368541',
      b05: '#3C9949',
      f01: '#CEF4CE',
      f02: '#32773B',
      f11: '#46BE59',
      main: '#368541',
    },
    tab: {
      default: '#121212',
      selected: '#0066A1',
    },
    type: 'light',
    umi: {
      bg: '#666666',
      mentioned: '#FA560A',
      text: '#FFFFFF',
    },
    vDanger: {
      f01: '#DD6057',
    },
    vDisabled: {
      f01: '#54565E',
    },
    vNeutral: {
      b01: '#1e2027',
      b02: '#282A32',
      b03: '#30323A',
      b04: '#383A43',
      f01: '#FFFFFF',
    },
    warning: {
      b01: '#FFF7EB',
      b02: '#FFE7C1',
      b03: '#F6AD16',
      f01: '#F6AD16',
      f02: '#896219',
      f11: '#F6AD16',
      main: '#F6AD16',
    },
  },
  radius: {
    circle: '50%',
    lg: '4px',
    md: '3px',
    round: '100vw',
    sm: '2px',
    xl: '8px',
    xxl: '16px',
    zero: '0px',
  },
  shadows: [
    'none',
    '0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)',
    '0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)',
    '0px 1px 8px 0px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 3px 3px -2px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  typography: {
    body1: {
      fontSize: '0.9375rem',
      fontWeight: 400,
      lineHeight: '22px',
    },
    body2: {
      fontSize: '0.9375rem',
      fontWeight: 700,
      lineHeight: '22px',
    },
    button: {
      fontSize: '0.9375rem',
      fontWeight: 700,
      lineHeight: '20px',
      textTransform: 'none',
    },
    caption1: {
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: '16px',
    },
    caption2: {
      fontSize: '0.75rem',
      fontWeight: 700,
      lineHeight: '16px',
    },
    codeFontFamily: 'Courier',
    display1: {
      fontSize: '2.125rem',
      fontWeight: 400,
      lineHeight: '40px',
    },
    display2: {
      fontSize: '2.8125rem',
      fontWeight: 400,
      lineHeight: '56px',
    },
    display3: {
      fontSize: '3.5rem',
      fontWeight: 700,
      lineHeight: '72px',
    },
    display4: {
      fontSize: '6rem',
      fontWeight: 700,
      lineHeight: '112px',
    },
    fontFamily: 'Lato, Helvetica, Arial, sans-serif',
    fontSize: 14,
    fontWeightBold: 700,
    fontWeightLight: 300,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    headline1: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: '32px',
    },
    headline2: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: '32px',
    },
    htmlFontSize: 16,
    subheading1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '24px',
    },
    subheading2: {
      fontSize: '1rem',
      fontWeight: 700,
      lineHeight: '24px',
    },
    title1: {
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: '28px',
    },
    title2: {
      fontSize: '1.25rem',
      fontWeight: 700,
      lineHeight: '28px',
    },
  },
  unit: '4px',
};

export default atosRich;
